import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Dashboard from './Dashboard';
import UsersBalanceSummaryTable from './UsersBalanceSummaryTable';

const DashboardVersionSwitch = () => {
    // Initialize state directly from localStorage to avoid initial render with wrong version
    const getInitialVersion = () => {
        const savedVersion = localStorage.getItem('dashboardVersion');
        return savedVersion || 'v2';
    };
    
    const [dashboardVersion, setDashboardVersion] = useState(getInitialVersion);
    const params = useParams();

    useEffect(() => {
        // Ensure localStorage has a default value if not set
        const savedVersion = localStorage.getItem('dashboardVersion');
        if (!savedVersion) {
            // Default to v2 if no preference is stored
            localStorage.setItem('dashboardVersion', 'v2');
        }
    }, []);

    // Listen for localStorage changes (when user switches in AccountPopover)
    useEffect(() => {
        const handleStorageChange = () => {
            const newVersion = localStorage.getItem('dashboardVersion');
            if (newVersion) {
                setDashboardVersion(newVersion);
            }
        };

        // Listen for storage events (for changes from other tabs)
        window.addEventListener('storage', handleStorageChange);

        // Also listen for custom events (for changes within the same tab)
        window.addEventListener('dashboardVersionChanged', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('dashboardVersionChanged', handleStorageChange);
        };
    }, []);

    // Render the appropriate dashboard component based on version
    
    if (dashboardVersion === 'v1') {
        return <UsersBalanceSummaryTable />;
    }

    return <Dashboard />;
};

export default DashboardVersionSwitch;
